import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import cn from 'classnames';
import { Tooltip } from '@material-ui/core';

import ColorStyles from '@components/ColorStyles';
import './BrToggle.scss';

export default class BrToggle extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    onText: PropTypes.string,
    offText: PropTypes.string,
    onColor: PropTypes.oneOf(Object.values(ColorStyles)),
    offColor: PropTypes.oneOf(Object.values(ColorStyles)),
    isOn: PropTypes.bool.isRequired,
    isDisabled: PropTypes.bool,
    isShort: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    tooltipText: PropTypes.string,
  };

  static defaultProps = {
    onText: 'On',
    offText: 'Off',
    onColor: ColorStyles.GREEN,
    offColor: ColorStyles.GRAY,
  };

  onClick = () => {
    const { onClick, isDisabled, isOn } = this.props;
    if (!isDisabled) {
      onClick(!isOn);
    }
  };

  toggleWithoutHover = (toggleClass, onText, offText) => {
    return (
      <div className={toggleClass} onClick={this.onClick} data-id="br-toggle">
        <div className="label-text on-text">{onText}</div>
        <div className="toggle-node" />
        <div className="label-text off-text">{offText}</div>
      </div>
    );
  };

  toggleWithHover = (toggleClass, onText, offText, tooltipText) => {
    return (
      <Tooltip arrow title={tooltipText} placement="top-start">
        <span className="inherit-width">{this.toggleWithoutHover(toggleClass, onText, offText)}</span>
      </Tooltip>
    );
  };

  render() {
    const { isOn, className, onText, offText, onColor, offColor, isDisabled, isShort, tooltipText } = this.props;
    const toggleClass = cn('br-toggle', className, `on${onColor}`, `off${offColor}`, {
      disabled: isDisabled,
      on: isOn,
      short: isShort,
      'inherit-width': !!tooltipText,
    });
    return tooltipText
      ? this.toggleWithHover(toggleClass, onText, offText, tooltipText)
      : this.toggleWithoutHover(toggleClass, onText, offText);
  }
}
